import React from 'react';
import { FormControlLabel } from '@mui/material';
import { StyledMuiSwitch } from './StyledSwitch.styles';
import PropTypes from 'prop-types';

const StyledSwitch = ({ label, ariaLabel, checked, onChange, disabled = false }) => {
  // If a label is provided, use FormControlLabel to associate it with the switch
  if (label) {
    return (
      <FormControlLabel
        control={<StyledMuiSwitch checked={checked} onChange={onChange} disabled={disabled} />}
        label={label}
      />
    );
  }

  // If no label but ariaLabel is provided, render just the switch with aria-label for accessibility
  return (
    <StyledMuiSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      inputProps={{ 'aria-label': ariaLabel }}
    />
  );
};

StyledSwitch.propTypes = {
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default StyledSwitch;
